import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, InputAdornment, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomPopupText from '../../../views/shared/CustomPopupText';
import VimeoIcon from './VimeoIcon';
import { MIN_QUERY_LEN } from '../constants';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  inputRoot: {
    height: 44,
    padding: '0 12px',
    border: '1px solid rgba(228, 231, 236, 1)',
    borderRadius: 8,
    background: 'rgba(254, 254, 254, 1)',
    boxSizing: 'border-box',
    marginTop: 12,
    marginBottom: 12,
  },
  input: {
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '21px',
    padding: '12px 0',
  },
  hint: {
    color: '#98A2B3',
    paddingLeft: 2,
  },
  error: {
    color: '#D92D20',
    paddingLeft: 2,
  },
});

export default function VimeoSearchBar({ query, onChange, isLoading, isRateLimited, msUntilReset }) {
  const classes = useStyles();

  const renderCaption = () => {
    if (query.length < MIN_QUERY_LEN) {
      return (
        <Typography variant="caption" className={classes.hint}>
          Type at least 3 characters to search
        </Typography>
      );
    }
    if (isRateLimited) {
      return (
        <Typography variant="caption" className={classes.error}>
          {`Search limit reached. Try again in ~${Math.ceil(msUntilReset / 1000)}s.`}
        </Typography>
      );
    }
    return null;
  };

  return (
    <div className={classes.root}>
      <CustomPopupText text="Search videos" />
      <TextField
        fullWidth
        autoComplete="off"
        value={query}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Type Here"
        InputProps={{
          disableUnderline: true,
          classes: { root: classes.inputRoot, input: classes.input },
          startAdornment: (
            <InputAdornment position="start">
              <VimeoIcon width={50} height={14} />
            </InputAdornment>
          ),
          endAdornment: isLoading ? (
            <InputAdornment position="end">
              <CircularProgress size={16} />
            </InputAdornment>
          ) : null,
        }}
      />
      {renderCaption()}
    </div>
  );
}

VimeoSearchBar.propTypes = {
  query: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isRateLimited: PropTypes.bool,
  msUntilReset: PropTypes.number,
};
